import {
  ApplyShipAuthorizationParams,
  Area,
  Ship,
  ShipListPageParams,
  ShipListPageResult,
  ShipVO,
} from "@/types/product";
import { handleRequest } from ".";
import { Authority } from "@/types/resource";
import { httpAuthorized } from "@/util/http";
import { BaseEnum } from "@/types/base";

export const getShipWithTypeListByAreaId = async (
  areaId: string
): Promise<ShipVO[] | null> => {
  return handleRequest<ShipVO[]>(
    httpAuthorized.get("/product/getShipListByAreaId", {
      params: { areaId },
    }),
    (data) => data.data.ships
  );
};

export const getShipInfoApi = async (
  shipId: string
): Promise<ShipVO | null> => {
  return handleRequest<ShipVO>(
    httpAuthorized.get("/product/getShipInfo", {
      params: {
        shipId: shipId,
      },
    }),
    (data) => data.data.ship
  );
};

export const getAreaInfoApi = async (areaId: string): Promise<Area | null> => {
  return handleRequest<Area>(
    httpAuthorized.get("/product/getAreaInfo", {
      params: {
        areaId: areaId,
      },
    }),
    (data) => data.data.area
  );
};

export const getAreaNameListApi = async (
  userId: string
): Promise<Area[] | null> => {
  return handleRequest<Area[]>(
    httpAuthorized.get("/product/getAreaNameList", { params: { userId } }),
    (data) => data.data.areas
  );
};

export const getShipAuthorityListApi = async (): Promise<
  Authority[] | null
> => {
  return handleRequest<Authority[]>(
    httpAuthorized.get("/product/getShipAuthorityList"),
    (data) => data.data.authorities
  );
};

export const submitShipAuthorizationApplyApi = async (
  params: ApplyShipAuthorizationParams
): Promise<string | null> => {
  return handleRequest<string>(
    httpAuthorized.post("/product/applyShipAuthorization", {
      ...params,
    }),
    (data) => data.info
  );
};

export const validateShipAuthorizationApi = async (
  shipId: string,
  authorityId: number
): Promise<boolean | null> => {
  return handleRequest<boolean>(
    httpAuthorized.get("/product/validateShipAuthorization", {
      params: {
        shipId: shipId,
        authorityId: authorityId,
      },
    }),
    (data) => data.data.result
  );
};

export const getDeviceErrorApi = async (
  eventId: string,
  eventType: number
): Promise<BaseEnum[] | null> => {
  return handleRequest<BaseEnum[]>(
    httpAuthorized.get("/mqtt/getDeviceErrorInfo", {
      params: {
        eventId: eventId,
        eventType: eventType,
      },
    }),
    (data) => data.data.result
  );
};

export const createAreaApi = async (
  userId: string,
  areaName: string
): Promise<boolean | null> => {
  return handleRequest<boolean>(
    httpAuthorized.post("/product/createArea", null, {
      params: {
        userId: userId,
        areaName: areaName,
      },
    }),
    (data) => data.data.result
  );
};

export const fetchOrganizationShipListApi = async (
  orgId: string
): Promise<ShipVO[] | null> => {
  return handleRequest<ShipVO[]>(
    httpAuthorized.get("/product/getOrganizationShipList", {
      params: {
        orgId: orgId,
      },
    }),
    (data) => data.data.ships
  );
};

export const createShipApi = async (ship: Ship): Promise<boolean | null> => {
  return handleRequest<boolean>(
    httpAuthorized.post("/product/createShip", ship),
    (data) => data.data.result
  );
};

/**
 * 分页查询全局船舶列表
 * @param params 分页及筛选参数（船舶名称模糊搜索、集团ID筛选）
 * @returns 船舶列表分页结果（含全表已授权船舶数）
 */
export const getShipListApi = async (
  params: ShipListPageParams
): Promise<ShipListPageResult | null> => {
  return handleRequest<ShipListPageResult>(
    httpAuthorized.get("/product/getShipList", { params }),
    (data) => data.data.result
  );
};
